/**
 * Parse Salesforce manager info pseudo-JSON format
 * Format: '{"Name","email@domain.com","(XXX) XXX-XXXX"}'
 * @param {string} rawInfo - Raw string from Salesforce
 * @returns {Array<string>|null} [name, email, phone] or null
 */
export function parseSalesforceManagerInfo(rawInfo) {
  if (!rawInfo || typeof rawInfo !== 'string') {
    return null;
  }

  try {
    // Remove outer quotes and braces, then split by ","
    const cleaned = rawInfo
      .trim()
      .replace(/^['"]?/, '') // Remove leading quote if exists
      .replace(/['"]?$/, '') // Remove trailing quote if exists
      .replace(/^{/, '') // Remove leading brace
      .replace(/}$/, ''); // Remove trailing brace

    // Split by "," pattern
    const parts = cleaned.split('","').map((part) => part.replace(/^"/, '').replace(/"$/, '').trim());

    // Expected format: [name, email, phone]
    // Return null if we don't have at least a name
    if (!parts[0]) {
      return null;
    }

    return [parts[0] || '', parts[1] || '', parts[2] || ''];
  } catch (error) {
    console.error('Error parsing Salesforce manager info:', error);
    return null;
  }
}

/**
 * Check if manager info is complete and valid
 * @param {Array<string>|null} personArray
 * @returns {boolean}
 */
export function hasValidManagerInfo(personArray) {
  return Array.isArray(personArray) && personArray[0] && personArray[0].length > 0;
}

/**
 * Format team member for BusinessContact component
 * @param {string} type - Team member type (e.g., 'case-manager', 'registration-contracting-specialist')
 * @param {string} rawInfo - Raw Salesforce data
 * @returns {Object} {type, person}
 */
export function formatTeamMember(type, rawInfo) {
  const person = parseSalesforceManagerInfo(rawInfo);

  return {
    type,
    person,
  };
}
